import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Lock, CreditCard } from 'lucide-react';
import { trackInitiateCheckout } from '../lib/pixel';
const includes = ['Cómo entender el negocio antes de pautar.', 'Qué modelos conviene publicitar si estás empezando.', 'Cómo crear ofertas simples para generar consultas.', 'Cómo usar anuncios de mensajes en Instagram.', 'Cómo evitar atraer consultas poco calificadas.', 'Plantillas de anuncios listas para adaptar.', 'Ejemplos de copies, hooks y estructuras.', 'Estrategias para tiendas, revendedores y personas que recién empiezan.'];
export function Pricing() {
  return <section id="comprar" className="py-20 md:py-32 bg-zinc-950 relative overflow-hidden" data-id="element-193">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-[500px] bg-blue-600/20 rounded-full blur-[100px] pointer-events-none" data-id="element-194"></div>

      <div className="max-w-4xl mx-auto px-4 md:px-6 relative z-10" data-id="element-195">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-196">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white tracking-tight mb-6" data-id="element-197">
            Accedé a la guía práctica de Sistema iPhone Ads
          </h2>
          <p className="text-base md:text-lg text-zinc-400 max-w-2xl mx-auto text-balance" data-id="element-198">
            Una guía pensada para dueños de tiendas, revendedores y personas que
            están empezando y quieren aprender a vender iPhones con anuncios más
            claros, más estratégicos y con mejores conversaciones.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl overflow-hidden shadow-2xl max-w-2xl mx-auto" data-id="element-199">
          <div className="p-8 md:p-12" data-id="element-200">
            <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-201">
              {/* Features */}
              <div data-id="element-202">
                <h3 className="text-lg font-bold text-zinc-900 mb-6 uppercase tracking-wider" data-id="element-203">
                  Qué incluye
                </h3>
                <ul className="space-y-4" data-id="element-204">
                  {includes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-205">
                      <CheckCircle2 className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" data-id="element-206" />
                      <span className="text-zinc-700 font-medium" data-id="element-207">{item}</span>
                    </li>)}
                </ul>
              </div>

              {/* Price & CTA */}
              <div className="bg-zinc-50 p-6 md:p-8 rounded-2xl border border-zinc-200 text-center" data-id="element-208">
                <div className="text-sm font-bold text-blue-600 uppercase tracking-wider mb-2" data-id="element-209">
                  Precio lanzamiento
                </div>
                <div className="text-4xl md:text-5xl font-extrabold text-zinc-900 mb-6" data-id="element-210">
                  $14.900{' '}
                  <span className="text-xl text-zinc-500 font-medium" data-id="element-211">ARS</span>
                </div>

                <a href="https://sistema-iphone-ads.myshopify.com/products/sistema-iphone-ads" onClick={trackInitiateCheckout} className="block w-full py-4 px-6 text-lg font-bold text-white bg-blue-600 rounded-xl hover:bg-blue-700 transition-colors shadow-lg hover:shadow-xl mb-4" data-id="element-212">
                  Comprar guía ahora
                </a>

                <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-zinc-500" data-id="element-213">
                  <div className="flex items-center gap-1" data-id="element-214">
                    <Lock className="w-4 h-4" data-id="element-215" /> Pago seguro
                  </div>
                  <div className="flex items-center gap-1" data-id="element-216">
                    <CreditCard className="w-4 h-4" data-id="element-217" /> Acceso digital
                  </div>
                  <div className="flex items-center gap-1" data-id="element-218">
                    <span aria-hidden data-id="element-219">·</span> Descarga inmediata
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Anchor Copy */}
          <div className="bg-blue-600 p-4 text-center" data-id="element-220">
            <p className="text-white font-medium text-sm md:text-base" data-id="element-221">
              "Con una campaña bien armada que te ayude a vender un equipo más,
              la guía ya puede pagarse sola."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}